import { createContext, use } from "react";

export const promiseCache = new Map<string, Promise<unknown>>();

/**
 * Caches the result of the provided async function based on the key
 * provided. If called again with the same key, the function will not
 * run and the previous result will be returned.
 */
export const promiseMemo = <T>(
  fn: () => Promise<T>,
  key: string,
  cache: Map<string, Promise<unknown>> = promiseCache,
): Promise<T> => {
  if (cache.has(key)) {
    return cache.get(key) as Promise<T>;
  }
  const promise = fn();
  cache.set(key, promise);
  return promise;
};

export const PromiseCacheContext = createContext(promiseCache);

export const usePromiseMemo = <T>(
  fn: () => Promise<T>,
  key: string,
): Promise<T> => {
  const cache = use(PromiseCacheContext);
  return promiseMemo(fn, key, cache);
};
